import * as React from "react";

export type TagProps = React.HTMLProps<any> & {
  html?: string;
  tag: string;

  children?: any;
};

const HTMLTag = React.memo((props: TagProps) => {
  const { tag, html, children, ...tagProps } = props;
  const Tag = tag as unknown as React.ComponentType<React.HTMLProps<any>>;

  return (
    <Tag {...tagProps} dangerouslySetInnerHTML={html ? { __html: html } : undefined}>
      {children}
    </Tag>
  );
});

export default HTMLTag;
